export default __webpack_public_path__ + "static/Calibre-Medium-c75a2cfb4c06fd961b18a14e3d01f49c.ttf";